import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import HistoryRowControls from '../../../../components/HistoryRowControls';
import HistorySection from '../../../../components/HistorySection';

import { formatPartialDate } from 'Utility/date';
import { getPatientAgeInMonthsWithOneDecimal } from '../../../../utility/patientInfo';
import { rulmScore, showPatientAgeInMonthsOnForm } from '../../utils';
import InfoPopover from '../../../../components/InfoPopover';
import HistoryRowListing from '../../../../components/HistoryRowListing';
import { Item } from '../../../../components/Grid';
import DocumentCreationButton from '../../../../components/DocumentCreationButton';

const RULM = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'motor.rulm'} />}
      newButton={
        <DocumentCreationButton
          name="rulm"
          text={'motor.newRULM'}
          onClick={startEdit({}, 'rulm')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={4}>
              <FormattedMessage id={'motor.rulmScoreRight'} />
            </Item>
            <Item xs={6}>
              <FormattedMessage id={'motor.rulmScoreLeft'} />
            </Item>
          </>
        }
        contentFormat={(d: IRULM): React.JSX.Element => (
          <>
            <Item xs={2} id={'rulmDate'}>
              {showPatientAgeInMonthsOnForm(d.date) ? (
                <FormattedMessage
                  id="motor.dateAndMonth"
                  values={{
                    date: formatPartialDate(d.date),
                    months: getPatientAgeInMonthsWithOneDecimal(d.date),
                  }}
                />
              ) : (
                formatPartialDate(d.date)
              )}
            </Item>
            <Item xs={4} id={'rulmRightScore'}>
              {rulmScore(d, 'Right') === 'notCounted' ? (
                <InfoPopover text="general.notFilled" color="primary" />
              ) : (
                rulmScore(d, 'Right')
              )}
            </Item>
            <Item xs={4} id={'rulmLeftScore'}>
              {rulmScore(d, 'Left') === 'notCounted' ? (
                <InfoPopover text="general.notFilled" color="primary" />
              ) : (
                rulmScore(d, 'Left')
              )}
            </Item>
          </>
        )}
        makeControls
        historyRowControls={(d: IControlProps) => (
          <div id={'rulmHistoryControl'}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </div>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IRULM[];
  startEdit: (document: TAnyObject, name?: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
  view?: IView;
}

export default RULM;
